import { AccountsAPI } from "api/axios.config";

const BASE_URL = "/Journals/Templates";
const IMPORT_URL = "/Journals/Import";

export const createJournalTemplate = async (data) => {
  return await AccountsAPI.post(BASE_URL, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
};

export const importJournalTemplate = async (file) => {
  const form = new FormData();
  form.append("File", file);
  form.append("FileName", file.name);

  const response = await AccountsAPI.post(IMPORT_URL, form);

  return response.data?.data ?? response.data;
};

export const getJournalTemplates = async () => {
  const response = await AccountsAPI.get(BASE_URL);
  return response.data?.data || [];
};

export const getJournalTemplateById = async (journalTemplateId) => {
  const response = await AccountsAPI.get(`${BASE_URL}/${journalTemplateId}`);
  return response.data?.data ?? response.data;
};

export const updateJournalTemplate = async (journalTemplateId, data) => {
  return await AccountsAPI.patch(
    `${BASE_URL}/${journalTemplateId}`,
    JSON.stringify({ data }),
    {
      headers: { "Content-Type": "application/json" },
    },
  );
};

export const deactivateJournalTemplate = async (journalTemplateId) => {
  const existing = await getJournalTemplateById(journalTemplateId);
  if (!existing) return;
  return await updateJournalTemplate(journalTemplateId, {
    ...existing,
    active: false,
  });
};
